import { Link } from "react-router-dom"

function toSlug(str = "") {
  return str.trim()
    .toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, "-")
}

const ESTADO_CONFIG = {
  distribucion: {
    label: "en distribución",
    icon: "fa-truck",
    className: "status-distribucion",
  },
  pendiente: {
    label: "pendiente",
    icon: "fa-spinner",
    className: "status-pendiente",
  },
  entregado: {
    label: "entregado",
    icon: "fa-check-double",
    className: "status-entregado",
  },
  cancelado: {
    label: "cancelado",
    icon: "fa-ban",
    className: "status-cancelado",
  },
  sin_procesos: {
    label: "sin envíos",
    icon: "fa-circle-minus",
    className: "status-unknown",
  },
}

function ListItem({ patient, showPrestador }) {
  const estado =
    ESTADO_CONFIG[patient.estado?.toLowerCase()] ?? {
      label: "desconocido",
      icon: "fa-circle-question",
      className: "status-unknown",
    }

  const inactivo = ["BAJA", "INACTIVO"].includes(patient.pacienteEstado)

  return (
    <div className={`listItem row${showPrestador ? " listItem--admin" : ""}${inactivo ? " listItem--inactivo" : ""}`}>
      <div className='row'>
        <i className="fa-regular fa-user"></i>
        <Link to={`/pacientes/${toSlug(patient.apellido)}/${toSlug(patient.nombre)}`}>
          {patient.apellido}, {patient.nombre}
        </Link>
      </div>
      {showPrestador && <div>{patient.prestador}</div>}
      <div>{patient.nroSocio}</div>
      <div>{patient.dni}</div>
      <div className={`estado ${estado.className} row alignCenter`}>
        <i className={`fa-solid ${estado.icon}`}></i>
        {estado.label}
      </div>
    </div>
  )
}

export default ListItem
